import React from 'react';
import { Box } from '@chakra-ui/react';

interface BrandIconProps {
  src: string;
  /** Chakra color token or css color the icon is tinted with */
  color?: string;
  boxSize?: string;
  /** override width/height independently (e.g. wide logo marks) */
  w?: string;
  h?: string;
  mr?: string | number;
}

/**
 * Renders an icon asset as a solid-color silhouette via CSS mask, so the
 * static green/blue SVG artwork follows the company brand (item 45) instead
 * of its baked-in colors.
 */
const BrandIcon: React.FC<BrandIconProps> = ({
  src, color, boxSize, w, h, mr,
}) => (
  <Box
    w={w ?? boxSize}
    h={h ?? boxSize}
    mr={mr}
    flexShrink={0}
    bg={color}
    sx={{
      WebkitMaskImage: `url(${src})`,
      maskImage: `url(${src})`,
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      WebkitMaskSize: 'contain',
      maskSize: 'contain',
      WebkitMaskPosition: 'center',
      maskPosition: 'center',
    }}
  />
);

BrandIcon.defaultProps = {
  color: 'brand.900',
  boxSize: '32px',
  w: undefined,
  h: undefined,
  mr: undefined,
};

export default BrandIcon;
